export default __webpack_public_path__ + "static/media/sa-title-en.9eddebb1.webp";